import script from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=3d56c4e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d56c4e6"]])

export default __exports__